import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { Content, P, SectionSubHeading } from "../../../styles";

import patricsign from "../../../images/patricsign.png";
const QouteBackgroundImage = styled.div`
  margin: auto;
  display: ${props => props.d? props.d: 'flex'};
  justify-content: center;
  flex-direction: column;
  min-height: 500px;
  max-height: 600px;
  max-width: 100%;
  max-width: 600px;
  background-image: url(${props => props.bk});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: ${props => props.p? props.p: '50px 40px 20px'};

  &.psm---mobileView,
  .psm---mobileView--heading{
    display: none;
  }
  @media screen and (max-width: 899px) {
    min-height: 250px;
    &.psm---mobileView{
        display: flex;
        align-items: center;
        padding: 0;
    }
    ${props => props.qoute? 
        null
        :
        `&.psm---desktopView{
            display: none;
        }`
    };
    

  }
  @media screen and (max-width: 599px) {
    .psm---mobileView--heading{
        display: block;
    }
  }
`;
const SignImages = styled.div`
  text-align: right;
  @media screen and (max-width: 599px) {
  }
`;
const SignHeading = styled.div`
  text-align: right;
  color: #f5f5ef;
  font-family: "PlayfairDisplay-SemiBold";
  font-size: 18px;
  @media screen and (max-width: 599px) {
    font-size: 16px;
  }
`;
const Italic = styled.span`
  font-family: "Poppins-SemiBoldItalic";
  font-size: 18px;
  @media screen and (max-width: 599px) {
    font-size: 16px;
  }
`;
const QoutePara = styled.div`
  font-family: "Poppins-Regular";
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : "#000")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  text-align-last: center;
  margin: ${(props) => (props.m ? props.m : "0")};
  padding: ${(props) => (props.padding ? props.padding : "0")};
  @media screen and (max-width: 599px) {
    font-size: 28px;
  }
`;
const Grids = styled(Grid)`
  text-align-last: right;
  @media screen and (max-width: 599px) {
    /* display: none; */
  }
`;
const GridDesktop = styled(Grid)`
  text-align: -webkit-center !important;
  text-align: -moz-center;
  @media screen and (max-width: 1270px) {
    text-align: unset !important;
    text-align: unset !important;
  }
`;
const SignImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 240px;
`;
const ContainerMain = styled(Container)`
    padding: 5% 16px;
`;
const Section = (props) => {
    const { order, sectionTitle, sectionContent, sectionImage, qoute, qouteBy, qouteSign } = props
    return (
        <ContainerMain maxWidth="xl">
            {!qoute? 
                <Grids item xs={12} md={6} style={{marginBottom: 40}} data-aos="fade-up" data-aos-duration="400" data-aos-easing="ease-in" data-aos-delay="400" data-aos-offset="0" >
                    <QouteBackgroundImage className="psm---mobileView" bk={sectionImage} data-aos="fade-up" data-aos-duration="400" data-aos-easing="ease-in" data-aos-delay="400" data-aos-offset="0" >
                        <SectionSubHeading className="psm---mobileView--heading" align="left" fs="75px" fs1270="59px" fs1014="51px" fs599="42px" color="#F5F5EF" padding="0" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-duration="600" data-aos-delay="500" data-aos-offset="0">
                            {sectionTitle}
                        </SectionSubHeading>
                    </QouteBackgroundImage>
                </Grids>
                : null
            }        
          <Grid container spacing={4} direction={ order % 2 == 0? 'row-reverse' : 'row' }>
            <GridDesktop item xs={12} md={6}>
                <QouteBackgroundImage d="block" p="0">
                    <SectionSubHeading className="psm---desktopView" qoute={qoute} align="left" fs="75px" fs1270="59px" fs1014="51px" fs599="42px" color="#0A0A0A" padding="0" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-duration="600" data-aos-delay="500" data-aos-offset="0">
                        {sectionTitle}
                    </SectionSubHeading>

                    <Content dangerouslySetInnerHTML={{__html: `${sectionContent}`}} fs380="12px" fs599="15px" fs="15px" maxWidth="100%" m="0"padding="0"data-aos="fade-up"data-aos-easing="ease-in"data-aos-duration="700"data-aos-delay="700"data-aos-offset="0"/>
              </QouteBackgroundImage>
            </GridDesktop>
            <Grids item xs={12} md={6} data-aos="fade-up" data-aos-duration="400" data-aos-easing="ease-in" data-aos-delay="400" data-aos-offset="0" >
              <QouteBackgroundImage bk={sectionImage}  className="psm---desktopView" qoute={qoute} data-aos="fade-up" data-aos-duration="400" data-aos-easing="ease-in" data-aos-delay="400" data-aos-offset="0" >
                {qoute? 
                    <>
                    <QoutePara padding="0" m="0" fs="32px" fs599="25px" color="#F5F5EF" align="center" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-duration="700" data-aos-delay="700" data-aos-offset="0" >
                        {qoute}
                    </QoutePara>

                    <SignImages data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-duration="800" data-aos-delay="800" data-aos-offset="0" >
                        {qouteSign?  <SignImage src={qouteSign} /> : null }
                        {qouteBy?  <SignHeading>{qouteBy}</SignHeading> : null }
                    </SignImages>
                    </> 
                    : null 
                }
              </QouteBackgroundImage>
            </Grids>
          </Grid>
        </ContainerMain>
    );
};

export default Section;

